import { enumToOptions } from '@libs/types/src/common/enum/util';
import { ActionEnum } from './action.enum';

export enum ResourceEnum {
    // ChCrm
    COLLECTION_STATISTICS = 'collectionStatistics',
    DONATION = 'donation',

    // Databox
    DATABOX = 'databox',

    // Editorial (Tema21)
    EDITORIAL = 'editorial',

    // Agenda biskupstvi
    AB_STATS = 'abStats',
    DMS = 'dms',

    // Email client
    EMAIL_CLIENT = 'emailClient',

    // xCarol
    FOLDER = 'folder',
    FORM = 'form',
    PERSON = 'person',
    FOLDER_RECORD = 'folderRecord',
    FOLDER_MEDICATION = 'folderMedication',
    WORK = 'work',
    WORK_SCHEDULER = 'workScheduler',
    WORK_SCHEDULER_WEEK_VIEW = 'workSchedulerWeekView',
    OPERATIONAL_WORK = 'operationalWork',
    DOCTOR_WORK = 'doctorWork',
    SPECIALIST_WORK = 'specialistWork',
    CARE_PLAN = 'carePlan',
    CARE_PAYMENT = 'carePayment',
    CALENDAR = 'calendar',
    MY_CALENDAR = 'myCalendar',
    CALENDAR_ABSENCE = 'calendarAbsence',
    CALENDAR_CHECKOUT = 'calendarCheckout',
    BILLING = 'billing',
    BILLING_RECEIPT = 'billingReceipt',
    VOUCHER = 'voucher',
    VOUCHER_DEADLINE = 'voucherDeadline',
    E_PRESCRIPTION = 'ePrescription',
    SICK_NOTE = 'sickNote',
    VOUCHER_PRESCRIBE = 'voucherPrescribe',
    SERVICE = 'service',
    SOCIAL_PROJECT = 'socialProject',
    SERVICE_DASHBOARD = 'serviceDashboard',
    BASIC_SOCIAL_CONSULTING = 'basicSocialConsulting',
    SERVICE_DIET = 'serviceDiet',
    WAITING_LIST = 'waitingList',
    WAREHOUSE_MATERIAL = 'warehouseMaterial',
    SUGGESTION_EVALUATION_ALL = 'suggestionEvaluationAll',
    SERVICE_ANNOUNCEMENT = 'serviceAnnouncement',
    SERVICE_ANNOUNCEMENT_HIDDEN = 'serviceAnnouncementHidden',
    DIAGNOSIS_BONIFICATION = 'diagnosisBonification',
    SYSTEM_PURO = 'systemPuro',
    SYSTEM_ENUM = 'systemEnum',
    FOLDER_DASHBOARD = 'folderDashboard',
    FOLDER_CONTACT = 'folderContact',
    CONTINUOUS_REPORT = 'continuousReport',
    INDIVIDUAL_WORK = 'individualWork',
    FOLDER_CONTRACT = 'folderContract',
    INDIVIDUAL_PLAN = 'individualPlan',
    TASK = 'task',
    WORK_SUGGESTION = 'workSuggestion',
    TANGIBLE_DEPOSIT = 'tangibleDeposit',
    FINANCIAL_DEPOSIT = 'financialDeposit',
    WORK_MOVEMENT_RESTRICTION = 'workMovementRestriction',
    WORK_SANCTION = 'workSanction',
    FOLDER_MAIL = 'folderMail',
    PLANNED_WORK = 'plannedWork',
    WORK_GROUP_ACTIVITY = 'workGroupActivity',
    WORK_MASS_WORK = 'workMassWork',
    FOLDER_NOTE = 'folderNote',
    PENSIONS_INCOME = 'pensionsIncome',
    CONTRACTUAL_SURCHARGE_INCOME = 'contractualSurchargeIncome',
    FINANCIAL_DEPOSIT_BULK = 'financialDepositBulk',
    DEFICIT_STATUS = 'deficitStatus',
    FINANCIAL_MOVEMENTS = 'financialMovements',
    CARE_CONTRIBUTION_REFUND = 'careContributionRefund',
    ACHO_ANALYSIS = 'achoAnalysis',
    PROVIDED_OPERATIONS_REPORT = 'providedOperationsReport',
    E_POUKAZ = 'ePoukaz',
    ATTENDANCE = 'attendance',
    ATTENDANCE_PRESCRIPTION = 'attendancePrescription',
    INDIVIDUAL_PLAN_DASHBOARD = 'individualPlanDashboard',
    SERVICE_ANNOUNCEMENT_DASHBOARD = 'serviceAnnouncementDashboard',
    FINANCIAL_BALANCE_DASHBOARD = 'financialBalanceDashboard',
    WORKED_HOURS_DASHBOARD = 'workedHoursDashboard',
    WORKERS_WORKED_HOURS_DASHBOARD = 'workersWorkedHoursDashboard',
    NURSING_ALLOWANCE = 'nursingAllowance',
    SOCIAL_CREDITS = 'socialCredits',
    TRASH = 'trash',
    ARCHIVE_DISPOSAL = 'archiveDisposal',
    ORGANIZATION_BILLING = 'organizationBilling',

    // Mado
    MADO_ACCOUNT = 'madoAccount',
    MADO_DEPARTMENT = 'madoDepartment',
    MADO_PROJECT = 'madoProject',
    MADO_BUDGET_CHAPTER = 'madoBudgetChapter',
    MADO_VAT_CODE = 'madoVatCode',
    MADO_VAT_CODE_LINE = 'madoVatCodeLine',
    MADO_RECONCILIATION = 'madoReconciliation',
    MADO_REPORT = 'madoReport',
    MADO_CREDIT_AGREEMENTS = 'madoCreditAgreements',

    // Common
    ORGANIZATION = 'organization',
    RULE = 'rule',
    USER = 'user',
    PASSWORD = 'password',
    FILES = 'files',
    ADMINISTRATION = 'administration',
    STATISTICS = 'statistics',
    ADDRESS_BOOK = 'addressBook',
    LIST = 'list',
    DESKA_MONITOR = 'deskaMonitor',
    SYSTEM = 'system',
    SYSTEM_GUIDE = 'systemGuide',
    USER_MESSAGE = 'userMessage',
    METHODICAL_MESSAGE = 'methodicalMessage',
    SERVICE_MESSAGE = 'serviceMessage',
}

export function allowedActions(resource: string): ActionEnum[] {
    switch (resource) {
        case ResourceEnum.MY_CALENDAR:
            return [ActionEnum.READ];
        case ResourceEnum.CALENDAR_ABSENCE:
        case ResourceEnum.CALENDAR_CHECKOUT:
            return [ActionEnum.READ, ActionEnum.CREATE, ActionEnum.UPDATE, ActionEnum.DELETE];
        case ResourceEnum.INDIVIDUAL_PLAN_DASHBOARD:
        case ResourceEnum.SERVICE_ANNOUNCEMENT_DASHBOARD:
        case ResourceEnum.FINANCIAL_BALANCE_DASHBOARD:
        case ResourceEnum.WORKED_HOURS_DASHBOARD:
        case ResourceEnum.WORKERS_WORKED_HOURS_DASHBOARD:
            return [ActionEnum.READ];
        case ResourceEnum.EDITORIAL:
            return [ActionEnum.READ, ActionEnum.CREATE, ActionEnum.UPDATE];
        case ResourceEnum.VOUCHER_PRESCRIBE:
        case ResourceEnum.PLANNED_WORK:
            return [ActionEnum.CREATE];
        default:
            return Object.values(ActionEnum);
    }
}

export const resourceEnumIndex = Object.values(ResourceEnum).reduce((acc, it, i) => {
    acc[it] = i;
    return acc;
}, {} as Record<ResourceEnum, number>);

export const resourceEnumOptions = enumToOptions(ResourceEnum, 'acl.rule.resource.');

export const chCrmResources = [
    ResourceEnum.COLLECTION_STATISTICS,
    ResourceEnum.DONATION,
];

export const databoxResources = [
    ResourceEnum.DATABOX,
];

export const editorialResources = [
    ResourceEnum.EDITORIAL,
];

export const xCarolResources = [
    ResourceEnum.FOLDER,
    ResourceEnum.ARCHIVE_DISPOSAL,
    ResourceEnum.FORM,
    ResourceEnum.PERSON,
    ResourceEnum.FOLDER_RECORD,
    ResourceEnum.WORK,
    ResourceEnum.WORK_SCHEDULER,
    ResourceEnum.OPERATIONAL_WORK,
    ResourceEnum.DOCTOR_WORK,
    ResourceEnum.SPECIALIST_WORK,
    ResourceEnum.CARE_PLAN,
    ResourceEnum.CALENDAR,
    ResourceEnum.MY_CALENDAR,
    ResourceEnum.CALENDAR_ABSENCE,
    ResourceEnum.CALENDAR_CHECKOUT,
    ResourceEnum.BILLING,
    ResourceEnum.BILLING_RECEIPT,
    ResourceEnum.VOUCHER,
    ResourceEnum.VOUCHER_DEADLINE,
    ResourceEnum.E_PRESCRIPTION,
    ResourceEnum.SICK_NOTE,
    ResourceEnum.VOUCHER_PRESCRIBE,
    ResourceEnum.STATISTICS,
    ResourceEnum.WAREHOUSE_MATERIAL,
    ResourceEnum.FOLDER_CONTACT,
    ResourceEnum.CONTINUOUS_REPORT,
    ResourceEnum.INDIVIDUAL_WORK,
    ResourceEnum.FOLDER_CONTRACT,
    ResourceEnum.INDIVIDUAL_PLAN,
    ResourceEnum.TASK,
    ResourceEnum.WORK_SUGGESTION,
    ResourceEnum.TANGIBLE_DEPOSIT,
    ResourceEnum.FINANCIAL_DEPOSIT,
    ResourceEnum.WORK_MOVEMENT_RESTRICTION,
    ResourceEnum.WORK_SANCTION,
    ResourceEnum.FOLDER_MAIL,
    ResourceEnum.PLANNED_WORK,
    ResourceEnum.WORK_GROUP_ACTIVITY,
    ResourceEnum.WORK_MASS_WORK,
    ResourceEnum.FOLDER_NOTE,
    ResourceEnum.PENSIONS_INCOME,
    ResourceEnum.CONTRACTUAL_SURCHARGE_INCOME,
    ResourceEnum.FINANCIAL_DEPOSIT_BULK,
    ResourceEnum.DEFICIT_STATUS,
    ResourceEnum.FINANCIAL_MOVEMENTS,
    ResourceEnum.CARE_CONTRIBUTION_REFUND,
    ResourceEnum.ACHO_ANALYSIS,
    ResourceEnum.PROVIDED_OPERATIONS_REPORT,
    ResourceEnum.E_POUKAZ,
    ResourceEnum.NURSING_ALLOWANCE,
    ResourceEnum.ATTENDANCE,
    ResourceEnum.ATTENDANCE_PRESCRIPTION,
    ResourceEnum.INDIVIDUAL_PLAN_DASHBOARD,
    ResourceEnum.SERVICE_ANNOUNCEMENT_DASHBOARD,
    ResourceEnum.FINANCIAL_BALANCE_DASHBOARD,
    ResourceEnum.WORKED_HOURS_DASHBOARD,
    ResourceEnum.WORKERS_WORKED_HOURS_DASHBOARD,
    ResourceEnum.SYSTEM_ENUM,
    ResourceEnum.SOCIAL_CREDITS,
    ResourceEnum.TRASH,
    ResourceEnum.ORGANIZATION_BILLING,
];

export const workResources = [
    ResourceEnum.WORK,
    ResourceEnum.DOCTOR_WORK,
    ResourceEnum.SPECIALIST_WORK,
    ResourceEnum.OPERATIONAL_WORK,
    ResourceEnum.CONTINUOUS_REPORT,
    ResourceEnum.INDIVIDUAL_WORK,
    ResourceEnum.WORK_SUGGESTION,
    ResourceEnum.TANGIBLE_DEPOSIT,
    ResourceEnum.WORK_MOVEMENT_RESTRICTION,
    ResourceEnum.WORK_SANCTION,
    ResourceEnum.WORK_GROUP_ACTIVITY,
    ResourceEnum.WORK_MASS_WORK,
];
